import { DatePicker, Input } from "antd";
import React, { useState } from "react";
import dayjs from "dayjs";
import Loader from "../../../pages/pages/loader";
import {
  useListCustomerCampaignPlatformQuery,
  useUpdateCustomerCampaignPlatformMutation,
} from "../../../redux/Api/CampaignManagment/cMCustomerCampaignPlatformApiSlice";
import AddCustomerPlatformModal from "./AddCustomerPlatformModal";
import { toast } from "react-toastify";

const CampaignFormStep2 = ({
  campaignId,
  campaignName,
  onPrevious,
  onSave,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [holder, setHolder] = useState(null);
  const {
    data: assignments,
    isLoading,
    refetch,
  } = useListCustomerCampaignPlatformQuery(
    { campaign: campaignId },
    { skip: !campaignId },
  );

  const [updateAssignment, { isLoading: isUpdating }] =
    useUpdateCustomerCampaignPlatformMutation();

  const handleAddNew = () => {
    setHolder(null);
    setModalOpen(true);
  };

  const handleEdit = (assignment) => {
    setHolder(assignment);
    setModalOpen(true);
  };

  const handleDuplicate = (assignment) => {
    const { id, ...rest } = assignment;
    setHolder(rest);
    setModalOpen(true);
  };

  const handleToggleActive = async (assignment) => {
    try {
      await updateAssignment({
        id: assignment.id,
        data: { is_active: !assignment.is_active },
      }).unwrap();
      refetch();
      toast.success("Entry deactivated successfully");
    } catch (error) {
      console.error("Error toggling active status:", error);
      toast.error("Failed to update assignment status");
    }
  };

  const entries = (assignments?.results || []).filter((e) => e.is_active);

  return (
    <div>
      <Loader isLoading={isLoading} />

      {/* Campaign Name */}
      <div className="mb-4">
        <div className="mb-3">
          <label className="form-label">Campaign Name</label>
          <Input
            type="text"
            value={campaignName || ""}
            className="text-gray-100 cursor-not-allowed"
            disabled
          />
        </div>
      </div>

      {/* Entries List - RH6 Style */}
      {entries.length > 0 ? (
        <div className="flex flex-col gap-3">
          {entries.map((entry) => (
            <div
              key={entry.id}
              className="flex gap-8"
              style={{
                background: entry.is_active
                  ? "rgba(60, 210, 165, 0.08)"
                  : "rgba(0, 0, 0, 0.3)",
                borderRadius: "8px",
                padding: "12px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
              }}
            >
              <div className="flex flex-col gap-2 w-[85%]">
                {/* Row 1: Customer, Platform, Start, End, Mode, Active, Actions */}
                <div className="grid grid-cols-4 gap-4">
                  <div className="mb-3 customSelect flex-1">
                    <label className="form-label">Customer</label>
                    <Input
                      type="text"
                      value={entry.customer_name}
                      disabled
                      className="text-gray-100 cursor-not-allowed"
                    />
                  </div>
                  <div className="mb-3 customSelect flex-1">
                    <label className="form-label">Platform</label>
                    <Input
                      type="text"
                      value={entry.platform_name}
                      disabled
                      className="text-gray-100 cursor-not-allowed"
                    />
                  </div>
                  <div className="mb-3 customeDate flex-1">
                    <label className="form-label">Start Date</label>
                    <DatePicker
                      style={{ width: "100%" }}
                      value={entry.start_date ? dayjs(entry.start_date) : null}
                      disabled
                    />
                  </div>
                  <div className="mb-3 customeDate flex-1">
                    <label className="form-label">End Date</label>
                    <DatePicker
                      style={{ width: "100%" }}
                      value={entry.end_date ? dayjs(entry.end_date) : null}
                      disabled
                    />
                  </div>
                </div>
                {/* Row 2: Rights Owner, Territory, Policy */}
                <div className="grid grid-cols-4 gap-8">
                  <div className="mb-3 flex-1">
                    <label className="form-label text-sm">Rights Owner</label>
                    <Input
                      className="text-gray-100 cursor-not-allowed"
                      value={entry.campaign_rights_owner}
                      disabled
                    />
                  </div>
                  <div className="mb-3 flex-1">
                    <label className="form-label text-sm">Territory</label>
                    <Input
                      className="text-gray-100 cursor-not-allowed"
                      value={entry.ownership_territory}
                      disabled
                    />
                  </div>
                  <div className="mb-3 flex-1">
                    <label className="form-label text-sm">Policy</label>
                    <Input
                      className="text-gray-100 cursor-not-allowed"
                      value={entry.policy}
                      disabled
                    />
                  </div>
                  <div className="mb-3 flex-1">
                    <label className="form-label">Duration</label>
                    <Input
                      className="text-gray-100 cursor-not-allowed"
                      value={entry.take_down_duration}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-2 items-center justify-center grow ">
                <button
                  className="btn btn-outline-theme btn-sm grow w-full"
                  onClick={() => handleEdit(entry)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-outline-theme btn-sm grow w-full"
                  onClick={() => handleDuplicate(entry)}
                >
                  Duplicate
                </button>
                <button
                  disabled={isUpdating}
                  className={`btn btn-sm grow w-full ${entry.is_active ? "text-danger border-danger hover:!text-white hover:!bg-[#ff6060]" : "btn-outline-theme"}`}
                  onClick={() => handleToggleActive(entry)}
                >
                  {entry.is_active ? "Deactivate" : "Activate"}
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-300 text-center p-4">
          No entries found for this campaign.
        </div>
      )}

      {/* Add Button */}
      <div className="mt-4 flex">
        <button className="btn btn-outline-theme flex-1" onClick={handleAddNew}>
          Add new entry
        </button>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-end gap-8 mt-4">
        <button onClick={onPrevious} className="btn btn-theme">
          Previous
        </button>
        <button onClick={onSave} className="btn btn-theme">
          Finish
        </button>
      </div>

      {/* Add/Edit Modal */}
      <AddCustomerPlatformModal
        open={modalOpen}
        setOpen={setModalOpen}
        campaignId={campaignId}
        holder={holder}
        refetch={refetch}
      />
    </div>
  );
};

export default CampaignFormStep2;
